import { onCanvas } from "../../shared/mouseFunctions";
import AbstractTool from "../AbstractTool";
import SelectionMenu from "../SelectionMenu";
import { COPY_APPEARANCE } from "../actions/ActionHelper";

export default class CopyStyleTool extends AbstractTool {
    resetPreviousTool = true;
    menu = new SelectionMenu(this.provider, 'edit');

    activate(appearance) {
        this.passArgs(appearance);
    }

    deactivate() {
        this.menu.remove();
        this.appearance = null;
        this.preview?.remove();
        this.preview = null;
        this.hoverSet.reset();
        this.provider.menu.resetCurrentToolIcon();
    }

    passArgs(appearance) {
        this.appearance = appearance;

        const fillCss = appearance.fillColor
            ? appearance.fillColor.toString('#rrggbb')
            : 'transparent';
        const strokeCss = appearance.strokeColor
            ? appearance.strokeColor.toString('#rrggbb')
            : '#999999';

        this.preview = this.p.createDiv()
            .size(40, 40)
            .style('border-radius', '50%')
            .style('background-color', fillCss)
            .style('border', `2px solid ${strokeCss}`)
            .style('box-sizing', 'border-box')
            .style('position', 'absolute')
            .style('z-index', '1000')
            .style('opacity', '0.8')
            .style('pointer-events', 'none')
            .position(this.p.mouseX, this.p.mouseY);

        const html = `<svg class="icon"><use xlink:href="/icons/__remixicon.sprite.svg#file-copy-line"></use></svg><svg style="position:absolute;bottom:-6px;right:-3px;width:14px;height:14px;" viewBox="0 0 14 14"><circle cx="7" cy="7" r="5.5" fill="${fillCss}" stroke="${strokeCss}" stroke-width="1.5"/></svg>`;
        this.provider.menu.setCurrentToolIcon(html);
    }

    display(g) {
        if (!this.touch && onCanvas(this.provider)) {
            this.preview.show();
        } else {
            this.preview.hide();
        }
    }

    dragMouse() { }

    pressMouseOnCanvas() {
        if (this.p.mouseButton === this.p.RIGHT) {
            let hovered = this.elements.hoveredAll();
            if (hovered.length > 1) {
                this.menu.refresh(hovered);
                return;
            }
        }
    }

    releaseMouseOnCanvas() { }

    clickMouseOnCanvas() {
        if (this.menu.initialized) {
            this.menu.remove();
            return;
        }
        let hovered = this.elements.hovered();
        if (hovered) {
            this.actions.execute(COPY_APPEARANCE, hovered, this.appearance);
            if (!this.mobile && !this.p.keyIsDown(this.p.SHIFT)) {
                this.tools.setTool('select');
                this.sideBar.setTab('info');
                this.selection.select(hovered);
            }
        }
    }

    doubleClickedOnCanvas() { }

    moveMouse() {
        this.cursor.cross();
        this.preview.position(this.p.mouseX, this.p.mouseY);
        if (!this.menu.initialized) {
            this.hoverSet.set(this.elements.hovered());
        }
    }

    getTips() {
        if (this.touch) {
            return 'Tap on an element to copy the style to it.';
        }
        return 'Click on an element to copy the style to it. Hold SHIFT to apply to multiple elements.';
    }

    pressKey(code) {
        switch (code) {
            case 27: // Esc
                if (this.menu.initialized) {
                    this.menu.remove();
                    return;
                }
                this.tools.setTool('select');
                break;
        }
    }

    pressKeyWithControl(code) { }
    pressKeyWithShift(code) { }
    pressKeyHotKeysDisabled(code) { }
}
